// extracted by mini-css-extract-plugin
export default {"name":"balance_name__ZMHqx","list":"balance_list__fSRyo"};